import { IsBoolean, IsIn, IsOptional, IsString } from 'class-validator';

export class UpdateConsentDto {
  @IsIn([
    'PLATFORM_IMPROVEMENT',
    'ANONYMIZED_STATISTICS',
    'MARKETING',
    'TOS_ACCEPTANCE',
    'TOS_UNFAIR_TERMS_1341',
  ])
  consentType!: string;

  @IsBoolean()
  granted!: boolean;

  @IsOptional()
  @IsString()
  clauseVersion?: string;
}
